import { FC, useEffect, useState } from 'react'
import { Modal, Form, Input, Space, Upload, UploadProps, InputNumber, Checkbox, message, Select } from 'antd'
import {
  ReloadOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  DeleteOutlined
} from '@ant-design/icons'
import styles from './index.module.scss'
import { UploadFile } from 'antd/lib/upload/interface'
import CategorySelect from '../CategorySelect'
import { uploadImageAction, getProductInfo } from '../../../services/productService'
import { getAuthHeaders } from 'bxl-auth'
import { nanoid } from 'nanoid'
import {
  StandardProduct,
  StandardProductsInfo,
  StarInfo,
  checkProduct,
} from '../../../services/standardProduct'
import { connect } from 'react-redux'

export const getErrorMessage = (response, message = 'error') => {
         return response?.response?.data?.messages?.[0] || response?.response?.data?.message || response?.message || message
       }
const getUploadData = (file) => {
  return {
    format: file && file.name.split('.').slice(-1)[0],
    topic: 'IMAGE_TEXT'
  }
}

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}
interface ProductInfoProps {
  visible: boolean
  onCancel: () => void
  productInfo: null | StandardProduct
  onAdd: (apiData: StandardProductsInfo) => Promise<void>
  onEditor: (id: string, info: StandardProductsInfo) => Promise<void>
  brandList: Record<string, any>
  starList: StarInfo[]
}

const ProductInfo: FC<ProductInfoProps> = ({ visible, onCancel, productInfo, onAdd, onEditor, brandList ,starList}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([])
  const [queryLoading, setQueryLoading] = useState(false)
  const [form] = Form.useForm()
  const [confirmLoading, setConfirmLoading] = useState(false)
  const fileListChangeHandler = ({ fileList }) => {
    setFileList(fileList)
  }

  const searchProductHandler = pid => {
    if(!pid) {
      return
    }
    setQueryLoading(true)
    checkProduct(pid).then(() => {
      getProductInfo(pid)
        .then(({ data }) => {
          if(!data) {
            return message.error(getErrorMessage('未查询到商品信息'))
          }
          form.setFieldsValue({
            brandId: data.brandId,
            name: data.name,
            categoryId: data.categoryIds?.[0],
            nameCN: data.nameCN,
          })
          setFileList(
            data.images?.slice(0, 8)?.map(image => ({
              uid: nanoid(),
              url: image.full.url,
              response: {
                full: image.full,
                thumbnail: image.thumbnail || {},
              },
            })) || []
          )
        })
        .catch(() => message.error(getErrorMessage('未查询到商品信息')))
        .finally(() => setQueryLoading(false))
    }).catch(err => {
      setQueryLoading(false)
      if(err?.response?.status === 409) {
        return message.error(`商品 ${pid} 已被关联`)
      }
      message.error(getErrorMessage(err))
    })
    
  }

  const moveLeft = (index: number) => {
    const list = [...fileList]
    const origin = list[index - 1] || {}
    const target = list[index] || {}
    list[index] = { ...origin }
    list[index - 1] = { ...target }
    setFileList(list)
  }

  const moveRight = (index: number) => {
    const list = [...fileList]
    const origin = list[index + 1] || {}
    const target = list[index] || {}
    list[index] = { ...origin }
    list[index + 1] = { ...target }
    setFileList(list)
  }
  
  const renderPictureCard: UploadProps['itemRender'] = (originNode, file, fileList, actions) => {
    const index = fileList.findIndex(item => item.uid === file.uid)
    return (
      <div className={styles['card-item-wrapper']}>
        <div className={styles['action-wrapper']}>
          {index > 0 && (
            <button onClick={() => moveLeft(index)}>
              <ArrowLeftOutlined />
            </button>
          )}

          {index < fileList.length - 1 && (
            <button
              onClick={() => {
                moveRight(index)
              }}
            >
              <ArrowRightOutlined />
            </button>
          )}

          <button onClick={actions.remove}>
            <DeleteOutlined />
          </button>
        </div>
        {originNode}
      </div>
    )
  }

  const onOk = () => {
    const images = fileList.map(image => {
      if(image.response) {
        const { full, thumbnail } = image.response || {}
        return { full, thumbnail }
      }
      return image
    })
    form.validateFields().then(res => {
      const { marketValue } = res
      const { starInfo  } = res
      if(starInfo) {
        const starId = findStarKey(res['starInfo'])
        const result = [] as Array<string>
        if(starId) {
          result.push(starId)
        }
        res['attributes'] = {'attributes': {'feature_ids':{'choices':result}}}
        delete res['starInfo']
      } else {
        delete res['starInfo']
        if(productInfo) {
          res['attributes'] = productInfo['attributes']
        }
      }
      console.log(res)
      const apiData = {
        ...res, 
        images,
        marketValue: typeof marketValue === 'number' ? marketValue * 100 : marketValue
      }
      console.log(apiData)
      setConfirmLoading(true)
      if(productInfo) {
        onEditor?.(productInfo.id, {...apiData, id: productInfo.id})?.then(res => {
          onCancel()
          setConfirmLoading(false)
        })
      }else {
        onAdd?.(apiData)
          ?.then(res => {
            onCancel()
          })
          .finally(() => setConfirmLoading(false))
      }
    })
  }

  const findStarKey = (value)=> {
      const starInfo = starList.find((element)=> element.value==value)
      return starInfo?.id
  }

  useEffect(() => {
    if(!visible) {
      setFileList([])
    }else {
      if(productInfo) {
        const { brandId, categoryId, imageScore, name, nameCN,
               articleNumber, marketValue, aggregateComment, images
        } = productInfo
        form.setFieldsValue({
          brandId, categoryId, imageScore, name, nameCN, articleNumber,
          marketValue: typeof marketValue === 'number' ? marketValue / 100 : marketValue,
          aggregateComment
        })
        setFileList(images?.slice(0, 8)?.map(image => ({
          uid: nanoid(),
          url: image.full.url,
          name: "",
          response: {
            full: image.full,
            thumbnail: image.thumbnail || {}
          }
        })) || [])
      }
    }
  }, [visible, productInfo, form])

  const getDefaultStar = () => {
    var a = ''
    if(productInfo) {
      console.log(productInfo)
      productInfo.attributes?.attributes?.feature_ids?.choices.map((option, index) => {
         const result = starList.find((element) => element.id == option)
         if(result?.value) {
          a  = result?.value
          return result?.value
         }
      })
    }
    console.log(a)
    return a ? a : null
  }


  return (
    <Modal
      destroyOnClose
      visible={visible}
      width={500}
      title="标品信息"
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
    >
      <Space size={20} direction="vertical" className={styles.full}>
        <Form.Item label="引用PID">
          <Input.Search
            allowClear
            placeholder="引用PID"
            onSearch={searchProductHandler}
            enterButton={<ReloadOutlined />}
            loading={queryLoading}
          />
        </Form.Item>
        <Upload
          fileList={fileList}
          action={uploadImageAction}
          listType="picture-card"
          maxCount={8}
          itemRender={renderPictureCard}
          showUploadList={{ showRemoveIcon: false }}
          onChange={fileListChangeHandler}
          accept="image/*"
          headers={getAuthHeaders() as Record<string, string>}
          name="full"
          data={getUploadData}
        >
          {fileList.length < 8 && (
            <Space size={10} direction="vertical" className={styles.full}>
              <PlusOutlined />
              <div>Upload</div>
            </Space>
          )}
        </Upload>
        <Form form={form} {...layout} preserve={false}>
          <Form.Item name="brandId" label="品牌" rules={[{ required: true, message: 'required' }]}>
            <Select placeholder="品牌" showSearch allowClear optionFilterProp="children">
              {Object.keys(brandList).map(brandId => (
                <Select.Option value={brandId} key={brandId}>
                  {brandList[brandId]?.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="name" label="英文名" rules={[{ required: true, message: 'required' }]}>
            <Input placeholder="英文名" />
          </Form.Item>
          <Form.Item name="nameCN" label="中文名" rules={[{ required: true, message: 'required' }]}>
            <Input placeholder="中文名" />
          </Form.Item>
          <Form.Item
            name="categoryId"
            label="类目"
            rules={[{ required: true, message: 'required' }]}
          >
            <CategorySelect placeholder="类目" leafOnly />
          </Form.Item>
          <Form.Item name="articleNumber" label="货号">
            <Input placeholder="货号" />
          </Form.Item>
          <Form.Item label="图像识别阀" name="imageScore">
            <InputNumber style={{ width: '100%' }} min={0} max={100} step={1} />
          </Form.Item>
          <Form.Item label="市场价" name="marketValue">
            <InputNumber prefix="￥" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="aggregateComment" valuePropName="checked" label="集合评论">
            <Checkbox />
          </Form.Item>
          <Form.Item label="明星同款" name="starInfo">
            <Select placeholder="明星同款" showSearch allowClear optionFilterProp="children" defaultValue={getDefaultStar}>
              {starList.map((option, index) => (
                <Select.Option key={index+option.id} value={option.value}>
                  {option.value}
                </Select.Option>
              ))}
            </Select>               
          </Form.Item>          
        </Form>
      </Space>
    </Modal>
  )
}

const mapStateToProps = store => {
  return {
    brandList: store.brands.brandList,
  }
}

export default connect(mapStateToProps)(ProductInfo)
 